import {ListViewPicker, SearchInput} from '@sollapay/ui/components';
import {useTranslation} from 'react-i18next';

import {ListSortingSelect} from '@/components';

import {TrustAccountFilter} from './TrustAccountFilter';

import type {TrustAccountFilterState} from '../utils/filter.utils';
import type {
  ListOnSortingChange,
  ListSortConfig,
  ListSortingState,
  ListView
} from '@sollapay/ui/components';
import type {ReactNode} from 'react';

/** `leading` sits after the search box, e.g. the member list's access filter buttons. */
export interface TrustAccountListToolbarProps<T> {
  searchText: string;
  onSearchChange: (searchText: string) => void;
  filter: TrustAccountFilterState;
  onFilterChange: (filter: TrustAccountFilterState) => void;
  sortConfig: ListSortConfig<T>;
  sorting: ListSortingState;
  onSortingChange: ListOnSortingChange;
  view: ListView;
  onViewChange: (view: ListView) => void;
  dateLabel?: string;
  leading?: ReactNode;
}

export function TrustAccountListToolbar<T>({
  searchText,
  onSearchChange,
  filter,
  onFilterChange,
  sortConfig,
  sorting,
  onSortingChange,
  view,
  onViewChange,
  dateLabel,
  leading
}: TrustAccountListToolbarProps<T>) {
  const {t} = useTranslation('trustAccounts');

  return (
    <div
      data-slot="trust-account-list-toolbar"
      className="flex flex-wrap items-center justify-between gap-3"
    >
      <div className="flex min-w-0 max-w-full flex-wrap items-center gap-3">
        <SearchInput
          value={searchText}
          onChange={onSearchChange}
          placeholder={t('search.placeholder')}
          className="w-80 max-w-full"
        />
        {leading}
      </div>
      <div className="flex min-w-0 max-w-full flex-wrap items-center gap-3">
        <TrustAccountFilter filter={filter} onChange={onFilterChange} dateLabel={dateLabel} />
        <ListSortingSelect
          config={sortConfig}
          sorting={sorting}
          onSortingChange={onSortingChange}
        />
        <ListViewPicker
          value={view}
          onChange={onViewChange}
          tableLabel={t('viewPicker.tableView')}
          cardLabel={t('viewPicker.cardView')}
        />
      </div>
    </div>
  );
}
